import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { createWebhook } from "../../api/apiWebhooks";
import parseError from "../../utils/parseError";

export const useCreateWebhook = () => {
    const queryClient = useQueryClient();

    const { mutate: createWebhookMutate, mutateAsync: createWebhookAsync, isPending: isCreating } = useMutation({
        mutationFn: createWebhook,
        onSuccess: (res) => {
            toast.success(res?.message || "Webhook created successfully");
            queryClient.invalidateQueries({ queryKey: ["webhooks"] });
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to create webhook");
        },
    });

    return { createWebhookMutate, createWebhookAsync, isCreating };
};
